module.exports = __webpack_public_path__ + "img/x.8e4986a5.svg";